/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-20 16:52:55
 * @LastEditors: Jack Deng
 * @LastEditTime: 2023-03-14 17:52:54
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/ProductReviewDetail/slice/index.ts
 */
import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import _ from 'lodash';
import moment from 'moment';
import { convertSalesChannelsFromSever } from 'src/constrains/Query1/Filter/PreConfig/SalesChannel/tools';
import { onTagClose } from 'src/constrains/Query1/tools';
import {
  getSearchCondition as _getSearchCondition,
  reducerTarget,
} from 'src/pages/ProductReview/slice/common';
import { EnumReducers } from 'src/pages/ProductReview/slice/contants';
import {
  changeStatus,
  deleteReply,
  deleteReview,
  getReview,
  postReply,
  postReview,
  publishAll,
  salesChannelOperations,
  unPublishAll,
} from 'src/request/review';
import {
  assData,
  reduxDefaultStatusControl,
  searchConditions,
} from 'src/tools/helper';
import { accAdd, accDiv } from 'src/tools/math';
import { getI18nFromGeneral } from 'src/tools/tools';
import { EnumReviewType } from '../../common';
import {
  //mapReviewFromServerToRedux,
  convertInitDataFromServerToRedux,
  //convertSingleReviewFromServerToRedux,
  convertProductReviewFromReduxToServer,
  updateSingleReview,
} from './common';
//import { store } from 'src/store';
// const legalEditorReducers = (state, reducer) => {
//   const reducers = [EnumReducers.virtualProduct, reducer];
//   const _r = reducerTarget(state, reducers);
//   return _r;
// };
const getTarget = (state) => reducerTarget(state, [EnumReducers.reviewDetail]);
export const fetchSpecReview = createAsyncThunk(
  'fetchSpecReview',
  async (params: { productUuid }, thunkAPI) => {
    // console.log(thunkAPI);
    // const data = store.getState();

    //const _d = getSearchCondition()(data);

    const { productUuid } = params;
    const response = await getReview(productUuid);
    return { response };
  },
);

export const postSpecReview = createAsyncThunk(
  'postSpecReview',
  async (params: { review }, thunkAPI) => {
    const { review } = params;
    const _review = convertProductReviewFromReduxToServer(review);
    const response = await postReview(_review);
    return { response };
  },
);

export const postSpecReply = createAsyncThunk(
  'postSpecReply',
  async (params: { reply }, thunkAPI) => {
    const { reply } = params;
    const response = await postReply(reply);
    return { response };
  },
);

export const deleteSpecReply = createAsyncThunk(
  'deleteSpecReply',
  async (params: { uuid }, thunkAPI) => {
    const { uuid } = params;
    const response = await deleteReply(uuid);
    return { response };
  },
);

const reviewPublishAll = createAsyncThunk(
  'publishToAllSalesChannels',
  async (params: { uuid }, thunkAPI) => {
    const { uuid } = params;
    const response = await publishAll(uuid);
    return { response };
  },
);

const reviewUnPublishAll = createAsyncThunk(
  'unPublishToAllSalesChannels',
  async (params: { uuid }, thunkAPI) => {
    const { uuid } = params;
    const response = await unPublishAll(uuid);
    return { response };
  },
);

const changeReviewStatus = createAsyncThunk(
  'changeReviewStatus',
  async (params: { uuid; status }, thunkAPI) => {
    const { uuid, status } = params;
    const response = await changeStatus(uuid, status);
    return { response };
  },
);

const reviewSalesChannelOperations = createAsyncThunk(
  'reviewSalesChannelOperations',
  async (params: { body }, thunkAPI) => {
    const { body } = params;
    const response = await salesChannelOperations(body);
    return { response };
  },
);

const reviewDeleteReview = createAsyncThunk(
  'deleteSpecReview',
  async (params: { uuid }, thunkAPI) => {
    const { uuid } = params;
    const response = await deleteReview(uuid);
    return { response, uuid };
  },
);

export {
  changeReviewStatus,
  getFilterSalesChannel,
  getProduct,
  getProductInfo,
  getSalesChannel,
  getSearchCondition,
  getSpecReview,
  getTabKey,
  reviewDeleteReview,
  reviewPublishAll,
  reviewSalesChannelOperations,
  reviewUnPublishAll,
};
const defaultState = {
  ...reduxDefaultStatusControl,
  searchConditions: {
    ...searchConditions,
    sort: {
      label: getI18nFromGeneral('general.review.productreview'),
      value: getI18nFromGeneral('general.review.productreview'),
      data: { needMoment: true, field: 'createdDate', ascent: true },
    },
  },
  tab: EnumReviewType.All,
  salesChannels: [],
  aggregation: {},
  orders: [], //{[uuid]:{data}}
  reviews: {}, //[uuid]
  storeUuid: '1',
  product: null,
};
const ProductReview = createSlice({
  name: 'storeProductReview',
  initialState: defaultState,
  reducers: {
    onSearchChange(state, action) {
      const _search = action.payload;
      state.searchConditions.search.push(_search);
    },
    onFilterChange(state, action) {
      const _filter = action.payload;
      Object.keys(_filter).forEach((key) => {
        state.searchConditions.filter[key] = _filter[key];
      });
    },
    onSortChange(state, action) {
      const _sort = action.payload;
      state.searchConditions.sort = _sort;
    },
    onSearchClose(state, action) {
      const item = action.payload;
      onTagClose({ state, item });
    },
    onTabChange(state, action) {
      state.tab = action.payload;
    },
    resetData(state) {
      assData(state, defaultState);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSpecReview.fulfilled, (state, action) => {
      const { response } = action.payload;
      convertInitDataFromServerToRedux({ state, data: response });
    });
    builder.addCase(postSpecReview.fulfilled, (state, action) => {
      const { response } = action.payload;

      updateSingleReview({
        state,
        channels: state.salesChannels || [],
        review: response,
      });
    });
    builder.addCase(postSpecReply.fulfilled, (state, action) => {
      const { response } = action.payload;
      updateSingleReview({
        state,
        channels: state.salesChannels || [],
        review: response,
      });
    });
    builder.addCase(deleteSpecReply.fulfilled, (state, action) => {
      const { response } = action.payload;
      updateSingleReview({
        state,
        channels: state.salesChannels || [],
        review: response,
      });
    });
    builder.addCase(reviewPublishAll.fulfilled, (state, action) => {
      const { response } = action.payload;
      updateSingleReview({
        state,
        channels: state.salesChannels || [],
        review: response,
      });
    });
    builder.addCase(reviewUnPublishAll.fulfilled, (state, action) => {
      const { response } = action.payload;
      updateSingleReview({
        state,
        channels: state.salesChannels || [],
        review: response,
      });
    });
    builder.addCase(changeReviewStatus.fulfilled, (state, action) => {
      const { response } = action.payload;
      updateSingleReview({
        state,
        channels: state.salesChannels || [],
        review: response,
      });
    });
    builder.addCase(reviewSalesChannelOperations.fulfilled, (state, action) => {
      const { response } = action.payload;
      updateSingleReview({
        state,
        channels: state.salesChannels || [],
        review: response,
      });
    });
    builder.addCase(reviewDeleteReview.fulfilled, (state, action) => {
      const { uuid } = action.payload;

      _.remove(state.orders, (item) => {
        return item === uuid;
      });

      delete state.reviews[uuid];
    });
  },
});

export const {
  onSearchChange,
  onFilterChange,
  onSortChange,
  onSearchClose,
  onTabChange,
  resetData,
} = ProductReview.actions;
export default ProductReview.reducer;

const getSearchCondition = () => {
  return _getSearchCondition(EnumReducers.reviewDetail);
};

const getTabKey = () => {
  return createSelector(
    (state: any) => {
      return getTarget(state).tab;
    },
    (tab) => {
      return tab;
    },
  );
};

const getSalesChannel = () => {
  return createSelector(
    (state: any) => {
      return getTarget(state).salesChannels;
    },
    (salesChannels) => {
      return salesChannels;
    },
  );
};

const getFilterSalesChannel = () => {
  return createSelector(
    (state: any) => {
      const channels = getTarget(state).salesChannels;
      return convertSalesChannelsFromSever({
        channels,
        hasConvertToLocales: true,
      });
    },
    (salesChannels) => {
      return salesChannels;
    },
  );
};

const getProduct = () => {
  return createSelector(
    (state: any) => {
      return getTarget(state).product;
    },
    (product) => {
      return product;
    },
  );
};

const getProductInfo = () => {
  const getAmount = ({ reviews, status }) => {
    return Object.keys(reviews).filter((i) => {
      return reviews[i].status === status;
    }).length;
  };
  return createSelector(
    (state: any) => {
      const product = getTarget(state).product;
      const reviews = getTarget(state).reviews;

      const totalAmount = Object.keys(reviews).length;
      const publishedAmount = getAmount({
        reviews,
        status: EnumReviewType.Published,
      });
      const spamAmount = getAmount({
        reviews,
        status: EnumReviewType.Spam,
      });
      const archiveAmount = getAmount({
        reviews,
        status: EnumReviewType.Archive,
      });
      const pendingAmount = getAmount({
        reviews,
        status: EnumReviewType.Pending,
      });
      const validRating = [
        EnumReviewType.Published,
        EnumReviewType.Pending,
        EnumReviewType.Archive,
      ];
      const validAmount = publishedAmount + archiveAmount + pendingAmount;
      const totalRating = Object.values(reviews).reduce((pre, now) => {
        const { rating = 0, status }: any = now || {};
        if (validRating.includes(status)) {
          const r = accAdd(rating, pre);
          return r;
        } else {
          return pre;
        }
      }, 0);

      const ave = totalAmount
        ? accDiv(totalRating, validAmount).toFixed(1)
        : '0.0';
      return {
        ave,
        pendingAmount,
        archiveAmount,
        spamAmount,
        publishedAmount,
        product,
        totalAmount,
      };
    },
    (info) => info,
  );
};

const getSpecReview = ({ type }) => {
  return createSelector(
    (state: any) => {
      const orders = getTarget(state).orders;
      const reviews = getTarget(state).reviews;

      const searchConditions = getTarget(state).searchConditions;
      const { filter, search, sort } = searchConditions;
      const { salesChannel, rating } = filter;

      let data = [];
      if (type === EnumReviewType.All) {
        data = orders.map((i) => {
          return reviews[i];
        });
      } else {
        data = orders.reduce((pre, now) => {
          const review = reviews[now];
          if (review.status === type) {
            return [...pre, review];
          }
          return pre;
          //return reviews[i].status===type
        }, []);
      }

      const searchText = search.map((i) => i.value);

      if (searchText.length > 0) {
        const _data = searchText.reduce((pre, text) => {
          const set = data.filter((i) => {
            const title = i.title || '';
            const content = i.content || '';
            const username = i.username || '';
            const customerName = i.customerName || '';
            const firstName = _.get(i, 'customer.firstName') || '';
            const lastName = _.get(i, 'customer.lastName') || '';
            const fullName = _.get(i, 'customer.fullName') || '';
            return (
              title.indexOf(text) !== -1 ||
              content.indexOf(text) !== -1 ||
              username.indexOf(text) !== -1 ||
              customerName.indexOf(text) !== -1 ||
              firstName.indexOf(text) !== -1 ||
              lastName.indexOf(text) !== -1 ||
              fullName.indexOf(text) !== -1
            );
          });
          return [...pre, set];
        }, []);
        data = _.intersectionBy(...(_data || []), 'uuid');

        // data = data.filter((i) => {
        //   const title = i.title || '';
        //   const content = i.content || '';
        //   const username = i.username || '';

        //   return (
        //     searchText.filter((text) => {
        //       return title.indexOf(text) !== -1;
        //     }).length > 0 ||
        //     searchText.filter((text) => {
        //       return content.indexOf(text) !== -1;
        //     }).length > 0 ||
        //     searchText.filter((text) => {
        //       return username.indexOf(text) !== -1;
        //     }).length > 0
        //   );
        // });
      }

      if (rating && rating.length > 0) {
        const [from, to]: any = rating;
        const _from = from.value;
        const _to = to.value;
        if (_from == _to) {
          data = data.filter((i) => {
            return i.rating === _from;
          });
        } else {
          data = data.filter((i) => {
            return i.rating >= _from && i.rating <= _to;
          });
        }
      }

      if (salesChannel && salesChannel.length > 0) {
        const channel = salesChannel[1];

        if (channel) {
          data = data.filter((i) => {
            return i.productReviewSalesChannels
              .map((i) => i.uuid)
              .includes(channel.value);
          });

          data = data.filter((i) => {
            const { productReviewSalesChannels } = i;
            const target =
              productReviewSalesChannels.find(
                (i) => i.uuid === channel.value,
              ) || {};
            return (target.locales || []).filter((i) => i.top).length > 0;
            //return locales.filter((i) => i.top).length > 0;
          });
        }
      }

      if (sort.data) {
        const { field, ascent, needMoment } = sort.data;

        data.sort((a, b) => {
          let point;
          if (needMoment) {
            const _a = moment(a[field]);
            const _b = moment(b[field]);

            point = _a.isBefore(_b);
          } else {
            point = a[field] > b[field];
          }
          // const point = ascent ? a[field] > b[field] : a[field] < b[field];
          return point ? -1 : 1;
        });
        if (ascent) {
          data.reverse();
        }
      }

      return data;
    },

    (data) => {
      return data;
    },
  );
};
